function ServiceUnavailable() {
  return (
    <div className='bg-neutral flex h-fit min-h-[100dvh] flex-col-reverse items-center justify-center px-5 pb-10 xl:flex-row'>
      <div className='flex flex-col gap-5'>
        <h2 className='text-center text-3xl leading-[1.2] text-[#BD111A] sm:text-5xl xl:text-left'>
          Uh-oh! <br /> Service Unavailable
        </h2>
        <p className='text-center text-base font-light text-black sm:text-lg xl:text-left'>
          It looks like our system is having a bit of a hiccup, but we&apos;re on it.
        </p>
        <p className='text-center text-base font-light text-black sm:text-lg xl:text-left'>
          Contact our admins at <span className='font-bold'>ignitemockexam@ondemand.in.th </span>
          if you need <br />
          any help while we get things back up and running. They&apos;ll be happy to assist you.
        </p>
      </div>
      <img
        className='w-full max-w-[600px]'
        src='/service-unavailable.svg'
        alt='service unavailable'
      />
    </div>
  );
}

export default ServiceUnavailable;
